<template>
  <div id="list-displayer">
    <div id="table-box" class="box">
      <table id="pins-table">
        <thead>
          <tr>
            <th>vide</th>
            <th> Nom </th>
            <th> Ville </th>
            <th> Region </th>
            <th> Pays </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="pin in pins" :key="pin.id" @click="$emit('pin-selected', pin)">
            <td>
              <img :src="iconForPin(pin)" alt="">
            </td>
            <td>{{ pin.name }}</td>
            <td>{{ pin.city }}</td>
            <td>{{ pin.region }}</td>
            <td>{{ pin.country }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { iconForPin } from '../utils/pinIcons'

defineProps({
  pins: {
    type: Array,
    required: true,
  },
})

defineEmits(['pin-selected'])
</script>
